<template>
  <main>
    <section class="banner-community">
      <div class="sloth-container">
        <div class="banner-community-content" v-scroll-reveal="{ delay: 120 }">
  
          <img class="banner-community-logo" src="/assets/images/logo.png" alt="">
  
          <h1>
            {{ $t('community.page.banner_title') }}
          </h1>
          <p>
  
            {{ $t('community.page.banner_description') }}
          </p>
  
          <div class="banner-community-social">
            <ul class="social-feed text-white">
              <li class="social-feed-item" v-scroll-reveal="{ delay: 251 }">
                <a href="https://www.facebook.com/slothtech.io" target="_blank">
                  <i class="fab fa-facebook-f"></i>
                </a>
              </li>
              <li class="social-feed-item" v-scroll-reveal="{ delay: 252 }">
                <a href="https://twitter.com/slothtech_io" target="_blank">
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li class="social-feed-item" v-scroll-reveal="{ delay: 253 }">
                <a href="https://instagram.com/slothtech.io" target="_blank">
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
              <li class="social-feed-item" v-scroll-reveal="{ delay: 254 }">
                <a href="https://www.youtube.com/channel/UCp01T2058TTy-IpI7HeZa9w" target="_blank">
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li class="social-feed-item" v-scroll-reveal="{ delay: 255 }">
                <a href="https://github.com/slothtechio" target="_blank">
                  <i class="fab fa-github"></i>
                </a>
              </li>
            </ul>
          </div>
  
        </div>
      </div>
    </section>
    <section class="community-information" v-scroll-reveal="{ delay: 120 }">
      <div class="sloth-container">
        <div class="community-information-grid">
          <div class="community-information-grid-item">
            <h3 v-scroll-reveal="{ delay: 120 }" class="community-information-title">
              {{$t('community.detail_title')}}
            </h3>
            <br>
            <p v-scroll-reveal="{ delay: 120 }" class="community-information-description">
                {{$t('community.detail_description')}}
            </p>
          </div>
          <div class="community-information-grid-item floating">
            <img v-scroll-reveal="{ delay: 120 }" src="/assets/images/SlothFlat.svg" alt="">
          </div>
        </div>
      </div>
    </section>
    <OurTech v-scroll-reveal="{ delay: 120 }" />
    <section class="community-events" v-scroll-reveal="{ delay: 120 }">
      <div class="sloth-container">
        <div class="community-events-frase">
          <h1 class="community-events-title">
            {{ $t('community.title')}}
          </h1>
          <blockquote class="quote-text">
            <p>
              {{ $t('community.description')}}
            </p>
            <cite class="quote-author"> 
                  Richard Stallman
              </cite>
          </blockquote>
        </div>
      </div>
  
      <div class="sloth-container">
        <div class="gallery-community">
          <lightbox v-for="(image, key) in images" :key="key" album="community" :src="image.url">
            <img :src="image.url">
          </lightbox>
        </div>
      </div>
  
    </section>
  
    <div class="bg-primary">
      <div class="sloth-container">
        <SimpleFooter/>
      </div>
    </div>
  
  </main>
</template>


<script>
  import OurTech from "../components/sections/OurTech";
  import SimpleFooter from "../components/shared/SimpleFooter";
  
  export default {
    name: "CommunityPage",
    components: {
      OurTech,
      SimpleFooter
    },
    data() {
      return {
        images: [{
            url: "/assets/images/community/slothtech_community-1.jpg"
          },
          {
            url: "/assets/images/community/slothtech_community-2.jpg"
          },
          {
            url: "/assets/images/community/slothtech_community-3.jpg"
          },
          {
            url: "/assets/images/community/slothtech_community-4.jpg"
          },
          {
            url: "/assets/images/community/slothtech_community-5.jpg"
          }
        ]
      };
    }
  };
</script>

<style scoped>
  .bg-primary {
    background: #3fc8c9;
  }
</style>

